<script setup lang="ts">

import AuthenticatedLayout from "@/layout/AuthenticatedLayout.vue";
import PageHeader from "@/components/PageHeader.vue";
import BaseResultsReport from "@/pages/Insights/ReportsDetailPage/components/BaseResultsReport.vue";
import UserValueScalesResultsTable from "@/pages/Insights/ReportsDetailPage/components/UserValueScalesResultsTable.vue";
import { computed } from "vue";
import {useReportingStore} from "@/store/reporting";

const reportingState = useReportingStore();
reportingState.resetState();
reportingState.setAvailableFilters({
  tenants: true,
  institutions: true,
  cohorts: true,
  curriculum: false
});

const breadcrumbItems = computed(() => [
  { text: "Insights", to: { name: "reports" } },
  { text: "User Value Scales", to: null }
]);

</script>

<template>
  <authenticated-layout :back-route="{ name: 'reports' }" :breadcrumbs="breadcrumbItems">

    <page-header
      title="User Value Scales"
      description="Explore user Value Scales results"
    />
    <BaseResultsReport
      data-endpoint="user-value-scales-results"
      metric-endpoint="users-completed-value-scales-ratio">
      <template #report-table="{ tableData }">
        <user-value-scales-results-table
          :loading-data="false"
          :report-data="tableData"
          class="borderless"
        />
      </template>
    </BaseResultsReport>
  </authenticated-layout>
</template>

<style scoped>

</style>
